import { grayPalette } from '../../../themes/colors';

export const searchLightTheme = {
  clearIndicatorColor: grayPalette[800],
  backgroundColor: grayPalette[0],
};
